import {Injectable} from '@angular/core';
import {RestangularModule, Restangular} from 'ngx-restangular';

@Injectable()
export class ManagementOfChangeService {

  constructor(private restangular: Restangular) {
  }

  getAllMOCReports() {
    return this.restangular.all('getAllMOCReports');
  }

  reportRemoveMOCUpdate() {
    return this.restangular.all('reportRemoveMOCUpdate');
  }

  getReportMOCFormData() {
    return this.restangular.one('getReportMOCFormData');
  }

  getTypeheadEmployees() {
    return this.restangular.one('getTypeheadEmployees');
  }

  reportMOCCRUD() {
    return this.restangular.all('reportChangeManagementRequests');
  }

  reportMocUpdate() {
    return this.restangular.all('reportMocUpdate');
  }

  reportMOCUD(id) {
    return this.restangular.one('reportChangeManagementRequests/' + id);
  }

  removeMeetingType() {
    return this.restangular.all('removeMeetingType');
  }

  getSegmentBySecondaryCompany() {
    return this.restangular.one('getSegmentBySecondaryCompany');
  }

  getTemplateAssignedRoute() {
    return this.restangular.one('getTemplateAssignedRoute');
  }

  reportMOCCreateNesr() {
    return this.restangular.all('reportMOCCreateNesr');
  }






  addRequireAmendmentDocs() {
    return this.restangular.one('addRequireAmendmentDocs');
  }

  getRequireAmendmentDocs() {
    return this.restangular.one('getRequireAmendmentDocs');
  }

  updateRequireAmendments() {
    return this.restangular.all('updateRequireAmendments3');
  }

  removeRequireAmendments() {
    return this.restangular.one('removeRequireAmendments');
  }

  updateDoesChangeAmendment(id) {
    return this.restangular.one('updateDoesChangeAmendment/' + id);
  }

  updateInitialRiskCategory() {
    return this.restangular.all('updateInitialRiskCategory');
  }

  submitReviewerApprove() {
    return this.restangular.all('submitReviewerApprove');
  }

  public getRiskRegisterRecords() {
    return this.restangular.one("getRiskRegisterRecords");
  }

  submitReportClose() {
    return this.restangular.all('submitReportClose');
  }

  submitReportReview() {
    return this.restangular.all('submitReportReview');
  }

  getApprovalsBySegment() {
    return this.restangular.one('getApprovalsBySegment');
  }


  getTypeheadEmployeesOnlyLPT() {
    return this.restangular.one('getTypeheadEmployeesOnlyLPT');
  }

  // reportPrintPreviewDataMoc() {
  //   return this.restangular.all('reportPrintPreviewDataMoc');
  // }

  reportPrintPreviewDataMoc() {
    return this.restangular.one('reportPrintPreviewDataMoc');
  }




}



// WEBPACK FOOTER //
// /app/src/app/services/management-of-change.service.ts